import { render, staticRenderFns } from "./carCheck.vue?vue&type=template&id=22394b9e&scoped=true"
import script from "./carCheck.vue?vue&type=script&lang=js"
export * from "./carCheck.vue?vue&type=script&lang=js"
import style0 from "./carCheck.vue?vue&type=style&index=0&id=22394b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22394b9e",
  null
  
)

export default component.exports